module.exports = __webpack_public_path__ + "mobile/img/img_bg_aboutus_contact.dae1af97.jpg";